module.exports = __webpack_public_path__ + "img/BEKAERT.6a87fb0f.jpg";